import { useRenameNichesFormModel } from './rename-niches-form.model'
import type { IRenameNichesForm } from './rename-niches-form.types'
import { RenameNichesFormView } from './rename-niches-form.view'

export const RenameNichesForm = ({ handleClose }: IRenameNichesForm) => {
  const renameNichesFormModel = useRenameNichesFormModel({ handleClose })
  return <RenameNichesFormView handleClose={handleClose} {...renameNichesFormModel} />
}
